<template>
  <b-container fluid>
    <b-row>
      <s-table
        striped
        responsive
        :items="value"
        :fields="fields"
        class="help-table"
      >
        <template #cell(description)="data">
          <div v-html="data.item.description"></div>
        </template>
      </s-table>
    </b-row>
  </b-container>
</template>

<script>
import physicalChemicalData from '@/domain/data/generalPanel/analysisProcessing/help-physical-chemical-items.json';
import chromatographyData from '@/domain/data/generalPanel/analysisProcessing/help-chromatography-items.json';

export default {
  name: 'HelpTable',
  props: {
    moduleSelected: {
      type: String,
    },
  },
  data() {
    return {
      value: [],
    };
  },
  created() {
    this.updateData();
  },
  watch: {
    moduleSelected() {
      this.updateData();
    },
  },
  methods: {
    updateData() {
      if (this.moduleSelected === 'physical-chemical') {
        this.value = this.getTranslatedData(physicalChemicalData);
      } else if (this.moduleSelected === 'chromatography') {
        this.value = this.getTranslatedData(chromatographyData);
      }
    },
    getTranslatedData(data) {
      return data.map(item => {
        let description = this.$t(item.description);

        if (item.values) {
          const valuesDescriptions = Object.keys(item.values)
            .map(
              key => `&nbsp;&nbsp;&nbsp;&nbsp;• ${this.$t(item.values[key])}`,
            )
            .join('<br>');

          description = `${description}<br>${valuesDescriptions}`;
        }

        return {
          term: this.$t(item.term),
          description,
          filling: this.$t(item.filling),
        };
      });
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'term',
          label: this.$t('general.term'),
          class: 'text-left',
        },
        {
          key: 'description',
          label: this.$t('general.description'),
          class: 'text-left',
        },
        {
          key: 'filling',
          label: this.$t('general.filling'),
          class: 'text-left',
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mixins"
@import "src/styles/defaults/variables"

.help-table
  ::v-deep
    .table
      border: solid 1px var(--color-gray-medium-light)
  @media print
    ::v-deep
      .table
  @media not print
    max-height: 500px
  ::v-deep
    .table
      min-width: 600px
      thead
      thead th
        background-color: var(--color-table-header-bg)!important
</style>
